import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import ConsoleWrapper from '@/docs-partials/endpoints/console';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Content By ID Endpoint`}</h2>
    <p>{`Same functionality as the Get GIF By ID endpoint, but generalized for any Giphy content (GIFs or Clips) based on given ID.`}</p>
    <h3>{`Request`}</h3>
    <ConsoleWrapper mdxType="ConsoleWrapper">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`GET /v1/content/:Id`}</td>
          </tr>
        </tbody>
      </table>
    </ConsoleWrapper>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Parameter:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required:`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description:`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`api_key`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Your issued API key`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`id`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ID of the content (GIF, Sticker, Clip)`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Response`}</h3>
    <p>{`Based on the content type of the given ID, the response`}</p>
    <h5>{`Success 200`}</h5>
    <ConsoleWrapper mdxType="ConsoleWrapper">
  <ul>
    <li>
      data: <a href="/docs/api/schema#gif-object">Gif</a>|<a href="/docs/clips/schema">Clip</a> Object
    </li>
    <li>
      meta: <a href="/docs/api/schema#meta-object">Meta Object</a>
    </li>
  </ul>
    </ConsoleWrapper>
    <h5>{`Error 4xx/5xx`}</h5>
    <ConsoleWrapper mdxType="ConsoleWrapper">
  <ul>
    <li>data: []</li>
    <li>
      meta: <a href="/docs/api/schema#meta-object">Meta Object</a>
    </li>
  </ul>
    </ConsoleWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      